import { render, staticRenderFns } from "./SongTemplate.vue?vue&type=template&id=7803a69f&scoped=true"
import script from "./SongTemplate.vue?vue&type=script&lang=ts"
export * from "./SongTemplate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7803a69f",
  null
  
)

export default component.exports